import { request as requestBase } from 'graphql-request';
import { useAuthStateStore } from '@annunciate/core';
export const requestWithAuth = async ({ endpoint, query, variables = {} }) => {
    const token = useAuthStateStore.getState().token;
    return requestBase(endpoint, query, variables, {
        authorization: token ? `Bearer ${token}` : '',
    });
};
//# sourceMappingURL=requestWithAuth.js.map